import * as $ from 'jquery';
import 'bootstrap';
import 'Dropzone';
import { recaptchaObject } from "./recaptcha";
import { bookingFormCommon } from "./c005-bookingform-common";

export class contactForm {
	private $contactEmailValid: string = '';
	private $contactError:Array<string> = [];
	private $scope:any = $('.contact-form--container[data-get-url]');
	private formEl:any = this.$scope.find('form').eq(0);
	private $dropzoneInstance:any;
	// private postUrl = this.formEl.attr('data-submit-url');
	private postUrl = '/bin/services/new/contactMediaTeamForm'; // hard code post url
	private bcommon = new bookingFormCommon();

	$fileUpload:any;

	validateEmail($contactEmailValid:string) {
		let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
	    return emailReg.test($contactEmailValid);
	}

	contactFormlist(): any {
		// every static rendering will use promise. no need to worry about async issue
		let defer = $.Deferred();
		let _self = this;
		// let dataUrl:string = _self.$scope.attr('data-get-url');
		let dataUrl:string = '/content/dam/mas/json/PhoneCode.json'; // hard code phone url req

		$.get(dataUrl)
		.done((data: any) => {
			let contactItems = "<option value=''> </option>";
			for (let i = 0; i < data.Phonecodes.length; i++) {
				contactItems +=  "<option value='" + data.Phonecodes[i].Code + "'>" + data.Phonecodes[i].Name + " (" + data.Phonecodes[i].Code + ")" + "</option>";
				contactItems += '</optgroup>';
			}
			defer.resolve(contactItems);
		})
		.fail((error:any) => {
			defer.reject(error);
		});

		return defer.promise();
	}

	initSelectize(contactItems: any): void {
		let _self = this;
		let contactSelect = _self.$scope.find('#contactCountryCode');
		let contactSelectTitle = _self.$scope.find('.contactCountryCode .booking-form--title');
		let contactSelectInputSelectize:any;
		contactSelect.html(contactItems);
		contactSelect.selectize({
			onInitialize: function() {
				contactSelectInputSelectize = $(contactSelect[0].selectize.$control[0]);
			},
			onFocus: function() {
				contactSelectTitle.addClass('input-filled');
				contactSelectInputSelectize.addClass('select-filled');
				contactSelectInputSelectize.removeClass('has-error');
				contactSelectTitle.removeClass('has-error');
			},
			onChange: function(value: any) {
				contactSelectTitle.addClass('input-filled');
				contactSelectInputSelectize.addClass('select-filled');
			},
			onBlur: function() {
				let $groupCountryCodeChange = $("#contactCountryCode option:selected").text();
				if ($groupCountryCodeChange == '') {
					contactSelectTitle.removeClass('input-filled');
					contactSelectInputSelectize.removeClass('select-filled');
				} else {
					contactSelectTitle.addClass('input-filled');
					contactSelectInputSelectize.addClass('select-filled');
				}
			},
			selectOnTab: true
		});
	}

	initFileUpload(): void {
		// prevent auto init of dropdown fields, manually init instead
		Dropzone.autoDiscover = false;

		let _self = this;
		let dropzoneField = _self.formEl.find('[data-dropzone]');
		let totalSize:number = 0;
		let uploadMessage:string = dropzoneField.attr('data-dropzone-message');
		let uploadLimit:number = parseInt(dropzoneField.attr('data-max-filesize-mb'));
		let uploadQty:number = parseInt(dropzoneField.attr('data-max-upload-qty'));
		let uploadLimitErrorMsg:string = dropzoneField.attr('data-error-upload-limit') + ' (' + uploadLimit + 'MB)';

		let fieldName:string = dropzoneField.attr('data-field-name');
		let errorContainer = _self.formEl.find('.contact-error--validation .error-msgs');

		_self.$fileUpload = dropzoneField.dropzone({
			url: _self.postUrl,
			maxFilesize: uploadLimit,
			maxFiles: uploadQty,
			addRemoveLinks: true,
		  autoProcessQueue: false,
		  uploadMultiple: true,
		  parallelUploads: 100,
		  dictDefaultMessage: uploadMessage,
			accept: function(file:any, done:any) {
				totalSize += parseFloat((file.size / (1024*1024)).toFixed(2));
				if (totalSize <= uploadLimit) {
					done();
				} else {
					if (!errorContainer.find('.validation--error-list').length) {
						errorContainer.append('<ul class="validation--error-list"></ul>');
					}

					// append error to error-container if max filesize exceeded (custom, not supported)
					if (!errorContainer.find('.validation--error-list li[data-id="dropzone-error"]').length) {
						errorContainer.find('.validation--error-list').last()
						.append('<li data-id="dropzone-error">'+ '<strong>' + fieldName + ':</strong> '+ uploadLimitErrorMsg +'</li>');
					}
					errorContainer.parent().show();
					done(uploadLimitErrorMsg);
				}
			},
			init:	function() {
				let instance = this;
				dropzoneField.removeClass('hidden');
				_self.$dropzoneInstance = instance;

				_self.$dropzoneInstance.on('addedfile', function(file:any) {
					dropzoneField.find('.dz-remove').each(function(i:number) {
						let item:any = $(this);

						item.off ('click.dropzone-remove').on('click.dropzone-remove', function(e:any) {
						});
					})
				});

				_self.$dropzoneInstance.on('success', function(file:any) {
					// todo: store name of file on server on submit
					// link uploaded images to form
				});

				_self.$dropzoneInstance.on("sendingmultiple", function(file:any, xhr:any, formData:any) {
					// append all other form data to this object when sending
					let otherFormData:Array<any> = _self.formEl.serializeArray();

					$.each(otherFormData, (i:number, field:any) => {
						formData.append(field.name, field.value);
					});
				});

				_self.$dropzoneInstance.on("queuecomplete", function(file:any, xhr:any, formData:any) {
					_self.submitSuccessfulHandler();
				});

				_self.$dropzoneInstance.on("removedfile", function(file:any) {
					totalSize -= parseFloat((file.size / (1024*1024)).toFixed(2));
					if (totalSize <= uploadLimit) {
						errorContainer.find('.validation--error-list li[data-id="dropzone-error"]').remove();

						// hide error parent container if main form has not triggered error yet
						if (!errorContainer.find('.contact-validator .validation--error-list').length) {
							errorContainer.parent().hide();
						}
					}
				});
		  }
		});
	}

	initRecaptcha():void {
		let _self = this;
		let _body = $('body');

		// temporary workaround for prod
		// - delete all old instances of recaptcha init and implement new method instead
		let recaptchaContainer:any = _self.$scope.find('[data-recaptcha]').parent();
		let recaptchaInputEl:any = $('<input type="text"/>');
		recaptchaContainer.empty();
		recaptchaInputEl.attr({
			'id': 'contact-recaptcha',
			'class': 'hidden',
			'name': 'complete recaptcha',
			'data-recaptcha': 'Validate is missing',
			'required': 'required',
			'readonly': 'readonly'
		});
		recaptchaContainer.append('<label class="hidden" for="contact-recaptcha">Recaptcha</label>');
		recaptchaContainer.append(recaptchaInputEl);
		recaptchaContainer.append('<div id="contact-form--grecaptcha"></div>');

		let recaptchaobj = new recaptchaObject();

		let recaptchaInfo:recaptchaInfo = {
			id: 'contact-recaptcha',
			cb: 'recaptchaContactSuccess',
			cbObj:	function (response:any) {
								(document.getElementById('contact-recaptcha') as HTMLInputElement).value = 'true';
							},
			displayId: 'contact-form--grecaptcha',
			formEl: _self.formEl
		};

		recaptchaobj.createRecaptchaField(recaptchaInfo);
	}

	/**
	 * on-the-fly form validators
	 * - name validation
	 * - number validation
	 */
	contactValidators(): void {
		let _self = this;

		_self.$scope.find('.name-validator').unbind('keydown').keydown(function (e: any) {
      // Allow: backspace, delete, tab, escape, enter
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
        // Allow: Ctrl/cmd+A
        (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl/cmd+C
        (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl/cmd+X
        (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
          // let it happen, don't do anything
          return;
      }
      // Ensure that it is a number and stop the keypress
      let arr: any = [8,16,17,20,32,35,36,37,38,39,40,45,46];
      for (let i = 65; i <= 90; i++) {
        arr.push(i);
      }
      if ($.inArray(e.which, arr) === -1) {
        event.preventDefault();
      }
    });

    // Allow: backspace, delete, tab, escape, enter
    _self.$scope.find('.num-validator').unbind('keydown').keydown(function (e: any) {
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
        // Allow: Ctrl/cmd+A
        (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl/cmd+C
        (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl/cmd+X
        (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
          // let it happen, don't do anything
           return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
      }
    });
	}

	/**
	 * submission form validation
	 * @return void
	 */
	contactSubmit(): void {
		let _self = this;

		_self.$scope.find('.contact-submit--btn').click((e:any) => {
			e.stopPropagation();
			e.preventDefault();

			// console.log(_self.$dropzoneInstance);
			let filesToUpload:Array<any> = [];

			if (_self.$dropzoneInstance !== undefined) {
				filesToUpload = _self.$dropzoneInstance.getQueuedFiles();
			}

			let $contactFirstName   : any = $('.contact-firstname');
			let $contactLastName    : any = $('.contact-lastname');
			let $contactCountryCode : any = $('#contactCountryCode');
			let $contactPhone       : any = $('.contact-phone');
			let $contactEmail       : any = $('.contact-email');
			let $contactSubject     : any = $('.contact-subject');
			let $contactHelp        : any = $('.contact-help');
			let $contactErrorDiv    : any = $('.contact-error--validation');
			let $contactValidator   : any = $('.contact-validator');
			let $contactRecaptchaDiv: any = $('#contact-recaptcha');

			let $contactEmailInput  : any = $contactEmail.val();
			let $validationSuccess  : any = true;

			_self.$contactError = [];
			$contactErrorDiv.show();

			/** Validate Contact First Name */
			if ($contactFirstName.val() == '') {
				let $contactFirstNameValidate:any = $contactFirstName.attr('data-contactFirstName');
				_self.$contactError.push('<strong>'+$contactFirstName.parent().find('label').text()+':</strong> '+$contactFirstNameValidate);
				$contactFirstName.addClass('has-error');
				$contactFirstName.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else {
				$contactFirstName.removeClass('has-error');
				$contactFirstName.parent().find('.booking-form--title').removeClass('has-error');
			}

			/** Validate Contact Last Name */
			if ($contactLastName.val() == '') {
				let $contactLastNameValidate:any = $contactLastName.attr('data-contactLastName');
				_self.$contactError.push('<strong>'+$contactLastName.parent().find('label').text()+':</strong> '+$contactLastNameValidate);
				$contactLastName.addClass('has-error');
				$contactLastName.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else {
				$contactLastName.removeClass('has-error');
				$contactLastName.parent().find('.booking-form--title').removeClass('has-error');
			}

			/** Validate Contact Email */
			if ((!(this.validateEmail($contactEmailInput))) || $contactEmailInput == '') {
				let $contactEmailValidate:any = $contactEmail.attr('data-contactEmail');
				_self.$contactError.push('<strong>'+$contactEmail.parent().find('label').text()+':</strong> '+$contactEmailValidate);
				$contactEmail.addClass('has-error');
				$contactEmail.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else {
				$contactEmail.removeClass('has-error');
				$contactEmail.parent().find('.booking-form--title').removeClass('has-error');
			}

			if ($contactCountryCode.val() == '') {
				$contactCountryCode.parent().find('.selectize-control .selectize-input').addClass('has-error');
				$contactCountryCode.parent().find('.booking-form--title').addClass('has-error');
				let $groupCountryCodeValidate:any = $contactCountryCode.attr('data-countrycode');
				_self.$contactError.push('<strong>'+$contactCountryCode.parent().find('label').text()+':</strong> '+$groupCountryCodeValidate);
				$validationSuccess = false;
			} else {
				$validationSuccess = $validationSuccess ? true : false;
				$contactCountryCode.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$contactCountryCode.parent().find('.booking-form--title').removeClass('has-error');
			}

      /** Validate Contact Phone */
      if ($contactPhone.val() == '') {
        let $contactPhoneValidate:any = $contactPhone.attr('data-contactPhone');
        _self.$contactError.push('<strong>'+$contactPhone.parent().find('label').text()+':</strong> '+$contactPhoneValidate);
        $contactPhone.addClass('has-error');
        $contactPhone.parent().find('.booking-form--title').addClass('has-error');
        $validationSuccess = false;
      } else {
        $contactPhone.removeClass('has-error');
        $contactPhone.parent().find('.booking-form--title').removeClass('has-error');
      }

      /** Validate Contact Subject */
      if ($contactSubject.val() == '') {
        let $contactSubjectValidate:any = $contactSubject.attr('data-contactSubject');
        _self.$contactError.push('<strong>'+$contactSubject.parent().find('label').text()+':</strong> '+$contactSubjectValidate);
        $contactSubject.addClass('has-error');
        $contactSubject.parent().find('.booking-form--title').addClass('has-error');
        $validationSuccess = false;
      } else {
        $contactSubject.removeClass('has-error');
        $contactSubject.parent().find('.booking-form--title').removeClass('has-error');
      }

      /** Validate Contact Help */
      if ($contactHelp.val() == '') {
        let $contactHelpValidate:any = $contactHelp.attr('data-contactHelp');
        _self.$contactError.push('<strong>'+$contactHelp.parent().find('label').text()+':</strong> '+$contactHelpValidate);
        $contactHelp.addClass('has-error');
        $contactHelp.parent().find('.booking-form--title').addClass('has-error');
        $validationSuccess = false;
      } else {
        $contactHelp.removeClass('has-error');
        $contactHelp.parent().find('.booking-form--title').removeClass('has-error');
      }

      /** Validate Contact Recaptcha */
      if ($contactRecaptchaDiv.val() == '') {
				let $contactRecaptchaDivValidate:any = $contactRecaptchaDiv.attr('data-recaptcha');
				this.$contactError.push('<strong>'+$contactRecaptchaDiv.parent().find('label').text()+':</strong> '+$contactRecaptchaDivValidate);
				$contactRecaptchaDiv.parent().addClass('has-error');
				$contactRecaptchaDiv.parent().find('.form-title').addClass('has-error');
				$validationSuccess = false;
			} else {
				$validationSuccess = $validationSuccess ? true : false;
				$contactRecaptchaDiv.parent().removeClass('has-error');
				$contactRecaptchaDiv.parent().find('.form-title').removeClass('has-error');
			}

			let $validationContainer:any = $contactValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$contactError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + this.$contactError[i] + '</li>');
			}

			if ($validationSuccess) {
				$contactErrorDiv.hide();

				// submit form via dropzone if have files to upload
				// else submit directly to post url
				if (_self.$dropzoneInstance !== undefined && filesToUpload.length) {
					_self.$dropzoneInstance.processQueue();
				} else {
					_self.bcommon.preloader();
					$.ajax({
						type: 'POST',
						url: _self.postUrl,
						data: _self.formEl.serialize(),
						success: function(res:any, textStatus:string, jqXHR:any){
							// hide form on successful submit
							_self.submitSuccessfulHandler();
						},
						error: function(requestObject:any, error:any, errorThrown:any) {
							_self.bcommon.preloaderClose();
						}
					});
				}
			}

			return $validationSuccess;
		});
	}


	/**
	 * 	if submit successful
	 * 	- hide form container
	 * 	- display success message
	 */
	submitSuccessfulHandler(): void {
		let _self = this;

		let $formSuccessMsg:any = _self.formEl.find('.form-success');
		let $formContainer:any = _self.formEl.find('.contact-form--content');

		_self.bcommon.preloaderClose();
		$formSuccessMsg.show();
		$formContainer.hide();

	}
}

let scope:Element = document.querySelector('.contact-form--container');
if (scope){
	try {
	let contactform = new contactForm();
	contactform.contactValidators();
	contactform.initRecaptcha();
  contactform.initFileUpload();
	contactform.contactSubmit();
	$(document).ready(function(){
		contactform.contactFormlist().then((contactItems: any) => {
			contactform.initSelectize(contactItems);
	  });
	});
	} catch(e) {console.error(e);}
}
